import React, { Component } from "react";

export default class Logout extends Component {
  render() {
    return <button className="btn" onClick={this.props.handleLogout}>Logout</button>
  }
}


// WEBPACK FOOTER //
// ./src/pages/Logout.js